"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var BreadcrumbItem = props => {
  return /*#__PURE__*/_react.default.createElement("ol", {
    className: "breadcrumb"
  }, props.breadcrumbs.map((crumb, index) => {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: index,
      className: "breadcrumb-item"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "".concat(crumb.targetLink)
    }, crumb.label));
  }));
};
var crumbItem = props => {
  return {
    targetLink: props.parentItem.url.toLowerCase(),
    label: (0, _lodash.isEmpty)(props.parentItem.field.pageName) ? props.parentItem.name : props.parentItem.field.pageName
  };
};
var parentValid = props => {
  return props.parentItem && props.parentItem.url !== '/';
};
var Breadcrumb = props => {
  if (!props || !props.rendering || !props.rendering.fields || !props.rendering.fields.data || !props.rendering.fields.data.contextItem) return null;
  var currentItem = props.rendering.fields.data.contextItem;
  var breadcrumbs = [];
  var parentItem = currentItem.parent;
  if (parentValid({
    parentItem
  })) {
    if (parentItem.field) breadcrumbs.push(crumbItem({
      parentItem
    }));
    parentItem = parentItem.parent;
    if (parentValid({
      parentItem
    })) {
      if (parentItem.field) breadcrumbs.push(crumbItem({
        parentItem
      }));
      parentItem = parentItem.parent;
      if (parentValid({
        parentItem
      })) {
        if (parentItem.field) breadcrumbs.push(crumbItem({
          parentItem
        }));
      }
    }
  }
  if (breadcrumbs.length > 0) {
    var breadcrumbProps = {
      breadcrumbs: breadcrumbs.reverse()
    };
    if (props.hero) {
      return /*#__PURE__*/_react.default.createElement("nav", {
        "aria-label": "breadcrumb"
      }, /*#__PURE__*/_react.default.createElement(BreadcrumbItem, breadcrumbProps));
    } else {
      return /*#__PURE__*/_react.default.createElement("nav", {
        "aria-label": "breadcrumb"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "no-border card ".concat(props.alignCenter ? 'align-items-center' : '')
      }, /*#__PURE__*/_react.default.createElement(BreadcrumbItem, breadcrumbProps)));
    }
  } else return null;
};
var _default = exports.default = Breadcrumb;